/**
 * @function Dswe
 * @description Apply DSWE water mask (keeps DSWE=1 or 2), f. DSWE decision tree (Jones et al., 2019)
 * @param {ee.Image} image to apply water mask
 * @returns {ee.Image} Single-band `dswe` image.
 */
export const Dswe = (image) => {
  const mndwi = Mndwi(image);
  const mbsrv = Mbsrv(image);
  const mbsrn = Mbsrn(image);
  const awesh = Awesh(image);
  const swir1 = image.select('B11');
  const nir = image.select('B8');
  const ndvi = Ndvi(image);
  const blue = image.select('B2');
  const swir2 = image.select('B12');

  const t1 = mndwi.gt(0.124);
  const t2 = mbsrv.gt(mbsrn);
  const t3 = awesh.gt(0);
  const t4 = mndwi.gt(-0.44).and(swir1.lt(900)).and(nir.lt(1500)).and(ndvi.lt(0.7));
  const t5 = mndwi.gt(-0.5).and(blue.lt(1000)).and(swir1.lt(3000)).and(swir2.lt(1000)).and(nir.lt(2500));

  const t = t1.add(t2.multiply(10)).add(t3.multiply(100)).add(t4.multiply(1000)).add(t5.multiply(10000));

  const noWater = t.eq(0).or(t.eq(1)).or(t.eq(10)).or(t.eq(100)).or(t.eq(1000));
  const hWater = t.eq(1111).or(t.eq(10111)).or(t.eq(11011)).or(t.eq(11101)).or(t.eq(11110)).or(t.eq(11111));
  const mWater = t
    .eq(111)
    .or(t.eq(1011))
    .or(t.eq(1101))
    .or(t.eq(1110))
    .or(t.eq(10011))
    .or(t.eq(10101))
    .or(t.eq(10110))
    .or(t.eq(11001))
    .or(t.eq(11010))
    .or(t.eq(11100));
  const pWetland = t.eq(11000);
  const lWater = t
    .eq(11)
    .or(t.eq(101))
    .or(t.eq(110))
    .or(t.eq(1001))
    .or(t.eq(1010))
    .or(t.eq(1100))
    .or(t.eq(10000))
    .or(t.eq(10001))
    .or(t.eq(10010))
    .or(t.eq(10100));

  const dswe = noWater
    .multiply(0)
    .add(hWater.multiply(1))
    .add(mWater.multiply(2))
    .add(pWetland.multiply(3))
    .add(lWater.multiply(4));

  return dswe.rename('dswe');
};

const Mndwi = (image) => image.normalizedDifference(['B3', 'B11']).rename('mndwi');

const Mbsrv = (image) =>
  image
    .select(['B3'])
    .add(image.select(['B4']))
    .rename('mbsrv');

const Mbsrn = (image) =>
  image
    .select(['B8'])
    .add(image.select(['B11']))
    .rename('mbsrn');

const Ndvi = (image) => image.normalizedDifference(['B8', 'B4']).rename('ndvi');

const Awesh = (image) => {
  return image
    .expression('Blue + 2.5 * Green + (-1.5) * mbsrn + (-0.25) * Swir2', {
      Blue: image.select('B2'),
      Green: image.select('B3'),
      mbsrn: Mbsrn(image).select('mbsrn'),
      Swir2: image.select('B12'),
    })
    .rename('awesh');
};
